import { render, staticRenderFns } from "./ModelVideoView.vue?vue&type=template&id=3b9b62ee&scoped=true"
import script from "./ModelVideoView.vue?vue&type=script&lang=js"
export * from "./ModelVideoView.vue?vue&type=script&lang=js"
import style0 from "./ModelVideoView.vue?vue&type=style&index=0&id=3b9b62ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9b62ee",
  null
  
)

export default component.exports